import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
	selector: 'app-advisor-teams',
	templateUrl: './advisor-teams.component.html',
	styleUrls: ['./advisor-teams.component.scss']
})
export class AdvisorTeamsComponent implements OnInit {

	current_page: any = 1;

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
		private dialog: MatDialog,
	) { }

	ngOnInit(): void {
		this.getAdvisors();
		this.getAdvisorTeams();
	}

	advisor_list: any = [];
	getAdvisors() {
		this.commonService.getData("/mtadvisorslist/").subscribe(
			(res: any) => {
				this.advisor_list = res["data"];
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	advisor_teams_list: any = [];
	advisor_teams_list_loaded: boolean = false;
	getAdvisorTeams() {
		this.advisor_teams_list_loaded = false;
		this.commonService.getData("/get_all_teams/").subscribe(
			(res: any) => {
				this.advisor_teams_list = res["data"];
				this.advisor_teams_list_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.advisor_teams_list = [];
				this.advisor_teams_list_loaded = true;
			},
		);
	}

	@ViewChild('createAdvisorTeamModal') createAdvisorTeamModal: TemplateRef<any>;
	private createAdvisorTeamModalRef: MatDialogRef<TemplateRef<any>>;

	selected_advisor_team: any = {
		id: "",
		name: "",
		description: "",
		primary_advisor_id: "",
		share_percentage: "",
		all_members: []
	};
	selected_advisor_team_errors: any = {
		id: false,
		name: false,
		description: false,
		primary_advisor_id: false,
		share_percentage: false,
		all_members: false
	};
	selected_advisor_team_type: any = "";
	openCreateAdvisorTeamModal(data, type) {

		this.selected_advisor_team = JSON.parse(JSON.stringify(data));
		this.selected_advisor_team_type = JSON.parse(JSON.stringify(type));

		this.createAdvisorTeamModalRef = this.dialog.open(this.createAdvisorTeamModal, { disableClose: true });
		this.createAdvisorTeamModalRef.afterClosed().subscribe((result) => {
			this.closeCreateAdvisorTeamModal();
		});
	}

	closeCreateAdvisorTeamModal() {
		this.createAdvisorTeamModalRef.close();
		this.resetAdvisorTeamData();
	}

	resetAdvisorTeamData() {
		this.selected_advisor_team = {
			id: "",
			name: "",
			description: "",
			primary_advisor_id: "",
			share_percentage: "",
			all_members: []
		};
		this.selected_advisor_team_errors = {
			id: false,
			name: false,
			description: false,
			primary_advisor_id: false,
			share_percentage: false,
			all_members: false
		};
		this.selected_advisor_team_type = "";
	}

	segregateOtherAdvisors() {

		if (this.selected_advisor_team_type == 'Add') {
			this.selected_advisor_team.all_members = [];
			this.selected_advisor_team.all_members = JSON.parse(JSON.stringify(this.advisor_list));

			for (let index = 0; index < this.selected_advisor_team.all_members.length; index++) {
				this.selected_advisor_team.all_members[index].checked = false;
				this.selected_advisor_team.all_members[index].advisor_id = this.selected_advisor_team.all_members[index].id;
				this.selected_advisor_team.all_members[index].advisor_name = this.selected_advisor_team.all_members[index].first_name + " " + this.selected_advisor_team.all_members[index].last_name;
				this.selected_advisor_team.all_members[index].share_percentage = "";
			}
		}

		const index = this.selected_advisor_team.all_members.findIndex(data => data.id == this.selected_advisor_team.primary_advisor_id);

		if (index > -1) {
			this.selected_advisor_team.all_members.splice(index, 1);
		}

	}

	assign_advisor_team_loader: boolean = false;
	assignAdvisorTeam() {
		// if (this.selected_advisor_team.id != "" && this.selected_advisor_team.id != null) {
		// 	this.selected_advisor_team_errors.id = false;
		// } else {
		// 	this.selected_advisor_team_errors.id = true;
		// }

		if (this.selected_advisor_team.name != "" && this.selected_advisor_team.name != null) {
			this.selected_advisor_team_errors.name = false;
		} else {
			this.selected_advisor_team_errors.name = true;
		}

		// if (this.selected_advisor_team.description != "" && this.selected_advisor_team.description != null) {
		// 	this.selected_advisor_team_errors.description = false;
		// } else {
		// 	this.selected_advisor_team_errors.description = true;
		// }

		if (this.selected_advisor_team.primary_advisor_id != "" && this.selected_advisor_team.primary_advisor_id != null) {
			this.selected_advisor_team_errors.primary_advisor_id = false;
		} else {
			this.selected_advisor_team_errors.primary_advisor_id = true;
		}

		if (this.selected_advisor_team.share_percentage != "" && this.selected_advisor_team.share_percentage != null && (parseInt(this.selected_advisor_team.share_percentage) < 100)) {
			this.selected_advisor_team_errors.share_percentage = false;
		} else {
			this.selected_advisor_team_errors.share_percentage = true;
		}

		for (let index = 0; index < this.selected_advisor_team.all_members.length; index++) {
			if (this.selected_advisor_team.all_members[index].checked == true) {
				this.selected_advisor_team_errors.all_members = false;
				break;
			} else {
				this.selected_advisor_team_errors.all_members = true;
			}
		}


		if (
			// this.selected_advisor_team_errors.id == false &&
			this.selected_advisor_team_errors.name == false &&
			// this.selected_advisor_team_errors.description == false &&
			this.selected_advisor_team_errors.primary_advisor_id == false &&
			this.selected_advisor_team_errors.share_percentage == false &&
			this.selected_advisor_team_errors.all_members == false
		) {
			let allocated_commission: any = 0;
			allocated_commission = allocated_commission + parseInt(JSON.parse(JSON.stringify(this.selected_advisor_team.share_percentage)));
			for (let index = 0; index < this.selected_advisor_team.all_members.length; index++) {
				if (this.selected_advisor_team.all_members[index].checked == true) {
					if (this.selected_advisor_team.all_members[index].share_percentage != "" && this.selected_advisor_team.all_members[index].share_percentage != null) {
						allocated_commission = (allocated_commission + (parseInt(this.selected_advisor_team.all_members[index].share_percentage)));
					} else {
						this.selected_advisor_team_errors.all_members = true;
						break;
					}
				} else {
					this.selected_advisor_team_errors.all_members = false;
				}
			}

			if (this.selected_advisor_team_errors.all_members == false) {
				if (allocated_commission == 100) {
					this.selected_advisor_team_errors.all_members = false;
				} else {
					this.selected_advisor_team_errors.all_members = true;
				}
			}

			if (this.selected_advisor_team_errors.all_members == false) {
				let payload: any = {
					team_id: this.selected_advisor_team_type == 'Add' ? 0 : this.selected_advisor_team.id,
					name: this.selected_advisor_team.name,
					description: this.selected_advisor_team.description,
					primary_advisor_id: this.selected_advisor_team.primary_advisor_id,
					share_percentage: this.selected_advisor_team.share_percentage,
					all_members: [],
				};

				if (this.selected_advisor_team_type == 'Add') {
					for (let index = 0; index < this.selected_advisor_team.all_members.length; index++) {
						if (this.selected_advisor_team.all_members[index].checked == true) {
							payload.all_members.push({
								advisor_id: this.selected_advisor_team.all_members[index].id,
								share_percentage: this.selected_advisor_team.all_members[index].share_percentage,
							});
						}
					}
				} else if (this.selected_advisor_team_type == 'Edit') {
					payload.all_members = this.selected_advisor_team.all_members;
				}

				// for (let index = 0; index < this.selected_table_data.length; index++) {
				// 	payload.prospects.push(this.selected_table_data[index].id);
				// }

				this.assign_advisor_team_loader = true;
				this.commonService.postData("/create_team/", payload).subscribe(
					(res: any) => {
						this.closeCreateAdvisorTeamModal();
						this.commonService.showToast('success', "Advisor Team Saved Successfully.");
						this.assign_advisor_team_loader = false;
						this.getAdvisorTeams();
					},
					(err) => {
						this.commonService.showToast('error', err.error);
						this.assign_advisor_team_loader = false;
					},
				);
			}
		}

	}

	@ViewChild('deleteModal') deleteModal: TemplateRef<any>;
	private deleteModalRef: MatDialogRef<TemplateRef<any>>;
	removeExistingRecord(data) {
		this.selected_advisor_team = data;
		this.deleteModalRef = this.dialog.open(this.deleteModal, { disableClose: true });
		this.deleteModalRef.afterClosed().subscribe((result) => {
			this.closeDeleteModal();
		});
	}

	closeDeleteModal() {
		this.resetAdvisorTeamData();
		this.deleteModalRef.close();
	}

	deleteRecord() {
		const payload = [this.selected_advisor_team.id];
		this.commonService.delete('/get_all_teams/destroy?ids=' + payload).subscribe(
			(res: any) => {
				this.getAdvisorTeams();
				this.commonService.showToast('success', 'Advisor Team Deleted Successfully.');
				this.closeDeleteModal();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	changeStatus(data) {
		const payload = {
			is_active: data.is_active,
			id: data.id,
		};
		this.commonService.patch('/update_team/' + data.id + '/', payload).subscribe(
			(res: any) => {
				this.getAdvisorTeams();
				this.commonService.showToast('success', 'Advisor Team Status Updated Successfully.');
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
		  return false;
		}
	}

	view_team_details: boolean = false;
	selected_view_team_data: any;
	selected_view_team_data_loaded: boolean = false;

	viewAdvisorTeam(data, type) {

		this.view_team_details = true;

		this.selected_advisor_team = JSON.parse(JSON.stringify(data));
		this.selected_advisor_team_type = JSON.parse(JSON.stringify(type));

		this.selected_view_team_data_loaded = false;

		let route: any = "";

		route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&team_id=" + this.selected_advisor_team.id;

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.table_columns = res["results"]['columns'];
				// for (let index = 0; index < this.table_columns.length; index++) {
				if (this.table_columns.length > 0) {
					let limit: any = 9;

					if (limit > this.table_columns.length) {
						limit = this.table_columns.length;
					}

					for (let index = 0; index < limit; index++) {
						this.table_columns[index].checked = true;
					}
				}
				// this.table_data = res['results']['data'];
				this.table_data = res['results']['data'];
				this.current_pagination_page = res["page_number"];
				this.total_pagination_records = res["total_no_of_records"];
				this.selected_view_team_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.selected_view_team_data_loaded = false;
			},
		);

	}

	back() {
		this.view_team_details = false;
		this.resetAdvisorTeamData();
		this.selected_view_team_data = {};
		this.selected_view_team_data_loaded = false;
	}

	selected_alphabet = '';
 	alphabets_array = [ 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', ];
	current_pagination_page = 1;
	total_pagination_records = 0;
	pagination_records_limit: any = 10;
	show_search: boolean = false;
	search_key: any = "";
	table_columns: any = [];
	table_data: any = [];
	table_columns_data: any = [];
	selected_table_data: any = [];
	table_data_loaded: boolean = false;
	show_toggle_columns: boolean = false;

	getKey(data, column) {
		const key = column['key'];
		return data[key];
	}

	pageChanged(event) {
		this.selected_table_data = [];
		this.current_pagination_page = event;
		this.pagination_records_limit = this.pagination_records_limit;
		this.viewAdvisorTeam(this.selected_advisor_team, this.selected_advisor_team_type);
	}

	is_selected: boolean = false;
	selectAll(event) {
		if (event.checked == true) {
			this.selected_table_data = JSON.parse(JSON.stringify(this.table_data));
			this.is_selected = true;
		} else {
			this.selected_table_data = [];
			this.is_selected = false;
		}
	}

	checkIndividualSelection(data) {
		const index = this.selected_table_data.findIndex((obj) => obj.id == data.id);
		if (index != -1) {
			return true;
		} else {
			return false;
		}
	}

	selectIndividual(event, data) {
		const index = this.selected_table_data.findIndex((obj) => obj.id == data.id);
		if (index != -1) {
			if (event.checked == true) {
				this.selected_table_data.splice(index, 0, data);
			} else {
				this.selected_table_data.splice(index, 1);
			}
		} else {
			this.selected_table_data.splice(index, 0, data);
		}

		if (this.table_data.length == this.selected_table_data.length) {
			this.is_selected = true;
		} else {
			this.is_selected = false;
		}
	}

	move_record_error: boolean = false;
  	@ViewChild('moveRecordModal') moveRecordModal: TemplateRef<any>;
	private moveRecordModalRef: MatDialogRef<TemplateRef<any>>;
	openMoveRecordModal() {
		if (this.selected_table_data.length > 0) {
			this.moveRecordModalRef = this.dialog.open(this.moveRecordModal, { disableClose: true });
			this.moveRecordModalRef.afterClosed().subscribe((result) => {
				this.closeMoveRecordModal();
			});
			this.move_record_error = false;
		} else {
			this.move_record_error = true;
		}
	}

	closeMoveRecordModal() {
		this.moveRecordModalRef.close();
		this.move_record_error = false;
	}

	unassign_prospects_loader: boolean = false;
	unassignProspects() {
		this.unassign_prospects_loader = true;
		let payload: any = {
			prospects: []
		};

		for (let index = 0; index < this.selected_table_data.length; index++) {
			payload.prospects.push(this.selected_table_data[index].id);
		}

		this.commonService.patch("/update_team/" + this.selected_advisor_team.id + "/", payload).subscribe(
			(res: any) => {
				this.closeMoveRecordModal();
				this.commonService.showToast('success', "Prospects Unassigned Successfully.");
				this.unassign_prospects_loader = false;
				this.current_pagination_page = 1;
				this.viewAdvisorTeam(this.selected_advisor_team, this.selected_advisor_team_type);
				this.selected_table_data = [];
				this.is_selected = false;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.unassign_prospects_loader = false;
			},
		);
	}

	show_user_profile: boolean = false;
	user_profile_data: any;
	showUserProfile(data) {
		this.user_profile_data = JSON.parse(JSON.stringify(data));
		this.show_user_profile = true;
	}

	profileClosed(event) {
		this.user_profile_data = {};
		this.show_user_profile = false;
	}

}
